import Img1 from "../assets/images/landing/blog-preview/blog-preview-375/post-1.jpeg";
import Img2 from "../assets/images/landing/blog-preview/blog-preview-375/post-2.jpeg";
import Img3 from "../assets/images/landing/blog-preview/blog-preview-375/post-3.jpeg";

const blogPreview = [
    {
        img: Img1,
        name: "Pizza-Teigarten im Vergleich",
        intro:
          "Begleite uns auf eine geschmackvolle Reise durch die verschiedenen Pizzaböden – jeder mit seinem eigenen Charakter und kulinarischen Charme.",
        date: "12. Juli 2024",
        author: "Daniel Wilson",
        id: 1,
        content: `Wenn es um Pizza geht, ist der Teig mehr als nur die Basis – er bestimmt Textur, Geschmack und das gesamte Erlebnis. Von dünn und knusprig bis dick und fluffig: Jede Teigart hat ihre regionalen Einflüsse und Besonderheiten. Werfen wir einen Blick auf die beliebtesten Varianten:
    
    1. Dünn & Knusprig – Der Klassiker  
    Diese Variante überzeugt mit zartem Crunch und leichtem Biss. Besonders beliebt in New York und Italien, wird sie bei hoher Hitze gebacken, damit die frischen Zutaten im Vordergrund stehen.
    
    2. Neapolitanisch – Der authentische italienische Stil  
    Aus Neapel stammend, ist dieser Teig dünn, weich und leicht zäh. Belegt mit San-Marzano-Tomaten, Mozzarella, Basilikum und Olivenöl – gebacken in einem Holzofen für ein luftiges, leicht verbranntes Aroma.
    
    3. Deep-Dish – Der Chicago-Klassiker  
    Für alle, die es deftig mögen: dicker, buttriger Boden, viel Käse, stückige Tomatensauce und kräftige Beläge – in einer tiefen Pfanne goldbraun gebacken.
    
    4. Gefüllter Rand – Die käsige Überraschung  
    Mit Käse, Knoblauchbutter oder anderen Zutaten gefüllt – für alle, die nicht genug von geschmolzenem Käse bekommen können.
    
    5. Vollkorn & Glutenfrei – Gesündere Alternativen  
    Für Gesundheitsbewusste oder bei Unverträglichkeiten: Vollkornteig mit nussiger Note oder glutenfreie Varianten aus Reis-, Mandelmehl oder Blumenkohl.
    
    6. Blumenkohlboden – Der Low-Carb-Trend  
    Blumenkohl, Käse und Ei ergeben einen festen, glutenfreien Teig – ideal für alle, die es leicht, aber lecker mögen.
    
    7. Focaccia-Style – Ein aromatischer Twist  
    Dicker, luftiger Boden mit Olivenöl und Kräutern – perfekt für rustikale, herzhafte Beläge.
    
    Ob knusprig oder soft, klassisch oder modern – Pizzaböden sind so vielfältig wie unsere Geschmäcker. Achte beim nächsten Mal genau auf den Teig – er ist das Fundament jedes Stücks!`,
      },
      {
        img: Img2,
        name:
            "Verschiedene Pizzateig-Arten für 8 klassische Pizzen",
        intro:
            "Beim Thema Pizza ist der Teig genauso wichtig wie der Belag. Jeder Pizzastil wird am besten durch eine bestimmte Teigart ergänzt, die Textur, Geschmack und das gesamte Erlebnis verbessert.",
        date: "1. Juli 2024",
        author: "Anna Anderson",
        id: 2,
        content: `Beim Thema Pizza ist der Teig genauso wichtig wie der Belag. Jeder Pizzastil wird am besten durch eine bestimmte Teigart ergänzt, die Textur, Geschmack und das gesamte Erlebnis verbessert. Ob du einen dünnen, knusprigen Biss oder ein dickes, üppiges Stück bevorzugst – der richtige Teig hebt den Geschmack und die Authentizität deiner Lieblingspizza auf ein neues Level. Lass uns 8 klassische Pizzen und ihre idealen Teigkombinationen erkunden, um dir bei der Auswahl der perfekten Basis für dein nächstes Stück zu helfen!
    
    Margherita-Pizza → Neapolitanischer Teig\n
    Ein echter italienischer Klassiker: Die Margherita-Pizza ist einfach, aber geschmackvoll und setzt auf hochwertige Zutaten wie San-Marzano-Tomaten, frischen Mozzarella, Basilikum und Olivenöl. Der beste Teig für diesen feinen Geschmack? Ein neapolitanischer Teig – dünn, weich und leicht zäh mit einer leichten Röstaroma aus dem Holzofen.\n
    Warum das funktioniert:\n
    ✔ Weiche, luftige Textur betont die frischen Zutaten.\n
    ✔ Leichte Röstaromen bringen eine rauchige Note.\n
    ✔ Authentisches italienisches Erlebnis.\n
    
    Pepperoni-Pizza → New Yorker Dünnteig\n
    Weltweit beliebt, verlangt die Pepperoni-Pizza nach einem Teig, der ihre kräftigen, würzigen Aromen zur Geltung bringt. Die beste Wahl? New Yorker Dünnteig – eine zusammenklappbare, leicht knusprige Basis mit einem zähen Biss, der großzügige Mengen an Käse und Pepperoni mühelos trägt.\n
    Warum das funktioniert:\n
    ✔ Stabil, aber dünn genug, um den Belag hervorzuheben.\n
    ✔ Knusprige Ränder mit leicht zäher Mitte.\n
    ✔ Perfekt zum Falten und unterwegs Genießen.\n
    
    Chicago-Style Deep Dish → Dicker, buttriger Teig\n
    Deep-Dish-Pizza steht für geschichtete Genüsse – ein dicker, buttriger Teig, der geschmolzenen Käse, stückige Tomatensoße und reichlich Belag trägt. Anders als traditionelle Pizza wird der Teig in einer tiefen Pfanne gebacken und erhält so eine blätterteigartige Textur.\n
    Warum das funktioniert:\n
    ✔ Extra-dicker Teig hält großzügige Belagschichten.\n
    ✔ Buttrige, goldbraune Ränder für reichhaltigen Geschmack.\n
    ✔ Typisches Chicagoer Wohlfühlessen.\n
    
    BBQ-Chicken-Pizza → Handgeworfener Teig\n
    Süß, rauchig und würzig – die BBQ-Chicken-Pizza passt am besten zu einem handgeworfenen Teig – nicht zu dick, nicht zu dünn, mit weichem Inneren und leicht knuspriger Außenseite. Dieses Gleichgewicht sorgt dafür, dass die kräftige BBQ-Soße und das zarte Hähnchen zur Geltung kommen, ohne vom Teig überdeckt zu werden.\n
    Warum das funktioniert:\n
    ✔ Leichte Knusprigkeit ergänzt die kräftigen BBQ-Aromen.\n
    ✔ Stabil genug für den Belag, ohne zu kompakt zu sein.\n
    ✔ Sorgt für einen angenehm zähen Biss.\n
    
    Gefüllte Krustenpizza → Klassischer Pfannenteig\n
    Für alle, die glauben, dass Käse alles besser macht, ist die gefüllte Krustenpizza der ultimative Genuss. Die beste Basis dafür? Ein klassischer Pfannenteig – dicker als handgeworfener, aber weicher als Deep-Dish, mit einem zähen, buttrigen Biss und einem mit Käse gefüllten Rand.\n
    Warum das funktioniert:\n
    ✔ Dick genug für extra Käse und Belag.\n
    ✔ Goldbraune, leicht knusprige Ränder als Kontrast.\n
    ✔ Reichhaltig und befriedigend bei jedem Bissen.\n
    
    Hawaiianische Pizza → Dünner & knuspriger Teig\n
    Die süß-herzhafte Kombination aus Ananas, Schinken und Käse auf der hawaiianischen Pizza harmoniert hervorragend mit einem dünnen und knusprigen Teig, der die frischen, tropischen Aromen in den Vordergrund stellt.\n
    Warum das funktioniert:\n
    ✔ Leichte, knusprige Basis bringt den Belag zur Geltung.\n
    ✔ Überdeckt nicht die Süße der Ananas.\n
    ✔ Feine Textur als Ausgleich zum salzigen Schinken.\n
    
    Weiße Pizza (Pizza Bianca) → Focaccia-Teig\n
    Anders als traditionelle Pizzen verzichtet die weiße Pizza auf Tomatensoße und setzt auf Knoblauch, Ricotta, Mozzarella und Olivenöl. Ein Focaccia-Teig – dicker, luftig und mit Kräutern verfeinert – unterstreicht ihre rustikalen Aromen.\n
    Warum das funktioniert:\n
    ✔ Weiche, fluffige Textur nimmt Knoblauch- und Olivenölaromen auf.\n
    ✔ Leicht knusprig außen, luftig innen.\n
    ✔ Ideal für reichhaltige, cremige Beläge.\n
    
    Vegane Pizza → Vollkorn- oder glutenfreier Teig\n
    Für pflanzenbasierte Pizza-Liebhaber bietet ein Vollkorn- oder glutenfreier Teig eine nussige, gesunde Basis, die zu Belägen wie gerösteten Pilzen, Rucola und milchfreiem Käse passt.\n
    Warum das funktioniert:\n
    ✔ Gesündere, ballaststoffreiche Option.\n
    ✔ Etwas dichter, aber dennoch knusprig.\n
    ✔ Anpassbar mit verschiedenen pflanzlichen Zutaten.\n
    
    Pizza ist ein harmonisches Zusammenspiel von Teig, Soße und Belag – und die richtige Basis hebt sowohl Textur als auch Geschmack hervor. Ob du nach einem dünn-knusprigen Biss, einer Deep-Dish-Sünde oder einer Überraschung mit Käserand suchst – jede Pizza hat ihren perfekten Teigpartner.\n
    Das nächste Mal, wenn du Pizza bestellst oder selbst backst, probiere verschiedene Teigstile aus – vielleicht entdeckst du dabei deinen neuen Favoriten! 🍕🔥`
    },
    {
        img: Img3,
        name: "Was tun mit übrig gebliebenem Pizzateig?",
        intro:
            "Übrig gebliebener Pizzateig? Bloß nicht wegwerfen! Diese vielseitige Zutat lässt sich in kreative, köstliche Leckereien verwandeln – von herzhaften Snacks bis zu süßen Verführungen.",
        date: "27. Juni 2024",
        author: "Catherine Wright",
        id: 3,
        content: `Übrig gebliebener Pizzateig? Bloß nicht wegwerfen! Diese vielseitige Zutat lässt sich in kreative, köstliche Leckereien verwandeln – von herzhaften Snacks bis zu süßen Verführungen. Hier sind 8 einfallsreiche Ideen, wie du deinen restlichen Teig neu nutzen kannst.
    
    1. Knoblauchknoten – Buttriger Genuss\n
    Forme kleine Knoten aus dem Teig, bestreiche sie mit Knoblauchbutter und Kräutern und backe sie goldbraun. Perfekt zum Snacken oder als Beilage mit Marinara-Soße.\n
    
    2. Mini-Calzones – Pizzas handlicher Cousin\n
    Fülle Teigkreise mit Käse, Fleisch und Gemüse, dann zusammenklappen und backen – ein einfaches, handliches Gericht. Füllungen lassen sich je nach Geschmack anpassen – ob herzhaft oder würzig.\n
    
    3. Zimt-Zucker-Stangen – Süße Versuchung\n
    Teig ausrollen, mit geschmolzener Butter, Zimt und Zucker bestreichen und knusprig backen. Mit Vanilleglasur oder Schokosoße servieren für extra Genuss.\n
    
    4. Käsige Brotsticks – Der perfekte Dip-Begleiter\n
    Teigstreifen mit geriebenem Mozzarella und Parmesan belegen, knusprig backen und mit Knoblauchbutter oder Marinara genießen.\n
    
    5. Herzhafte Teigtaschen – Geschmackvoller Snack für unterwegs\n
    Fülle den Teig mit Käse, gegartem Fleisch oder Gemüse. Verschließen, backen und als leckere, tragbare Mahlzeit genießen.\n
    
    6. Pretzel Bites – Ein spaßiger Dreh\n
    Teigstücke in Natronwasser kochen, dann backen und mit Salz bestreuen – für hausgemachte weiche Brezeln.\n
    
    7. Fruchtige Teigteilchen – Frühstücks-Favorit\n
    Frische Äpfel, Beeren oder Nutella in Pizzateig einwickeln, backen und mit Puderzucker bestäuben.\n
    
    8. Pizza-Schnecken – Spaßiger Party-Snack\n
    Käse, Soße und Belag auf dem Teig verteilen, aufrollen, in Scheiben schneiden und backen. Perfekt für Spieleabende und Partys.\n
    
    Mit ein wenig Kreativität wird aus übrig gebliebenem Pizzateig eine Vielzahl köstlicher Gerichte. Verschwende ihn nicht – mach etwas Großartiges daraus!\n`
    },
]

export default blogPreview;
